import { render, staticRenderFns } from "./StageInspectionCompleted.vue?vue&type=template&id=70bc0e7d&"
import script from "./StageInspectionCompleted.vue?vue&type=script&lang=ts&"
export * from "./StageInspectionCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports